import { ReactNode } from "react";
import { NumberProperty } from "../widgetproperties/NumberProperty";
import { AbstractWidgetSettings } from "./AbstractWidgetSettings";
import classes from "./AbstractWidgetSettings.module.css";
import { BooleanProperty } from "../widgetproperties/BooleanProperty";
import { TextProperty } from "../widgetproperties/TextProperty";
import { Flex } from "antd";
import { CloseOverlayButton } from "../../Overlay/Overlay";
import { MaxLen } from "./media/MaxLen";
import { Tarification } from "./media/Tarification";
import { reaction } from "mobx";

export class MediaWidgetSettings extends AbstractWidgetSettings {
  constructor() {
    const vkRequests = new BooleanProperty({
      name: "vkvideoEnabled",
      value: true,
      displayName: "Реквесты с VKVideo",
    });
    const tarification = new Tarification();
    reaction(
      () => tarification.value.method,
      () => {
        if (tarification.value.method === "perMinute") {
          vkRequests.value = false;
        }
      },
    );
    reaction(
      () => vkRequests.value,
      () => {
        if (vkRequests.value) {
          tarification.value.method = "perLink";
        }
      },
    );
    super({
      sections: [
        {
          key: "general",
          title: "Общие",
          properties: [
            new BooleanProperty({
              name: "requestsEnabled",
              value: true,
              displayName: "Реквесты включены",
            }),
            new BooleanProperty({
              name: "youtubeEnabled",
              value: true,
              displayName: "Реквесты с YouTube",
            }),
            vkRequests,
            tarification,
            new NumberProperty({
              name: "songMaxAmount",
              value: 12,
              displayName: "Максимальное кол-во видео в одном донате",
            }),
            new NumberProperty({
              name: "requestViewAmount",
              value: 100,
              displayName: "Минимальное кол-во просмотров",
            }),
            new MaxLen(),
            new TextProperty({
              name: "requestTooltip",
              value: "",
              displayName: "Текст подсказки для донатера",
            }),
            new TextProperty({
              name: "wordsBlacklist",
              value: "",
              displayName: "Blacklist слов в названии",
            }),
          ],
        },
        {
          key: "appearance",
          title: "Внешний вид",
          properties: [
            new NumberProperty({
              name: "playlistSongTitleFontSize",
              value: 16,
              addon: "px",
              displayName: "widget-media-title-font-size",
            }),
            new NumberProperty({
              name: "playlistNicknameFontSize",
              value: 16,
              addon: "px",
              displayName: "widget-media-customer-font-size",
            }),
          ],
        },
        {
          key: "twitch-requests",
          title: "Twitch",
          properties: [
            new BooleanProperty({
              name: "twitchPointsRequestsEnabled",
              value: false,
              displayName: "Заказ за баллы",
            }),
            new TextProperty({
              name: "music-twitch-request-title",
              value: "Заказ музыки",
              displayName: "Название награды",
            }),
            new NumberProperty({
              name: "music-twitch-request-cost",
              value: 100,
              displayName: "Стоимость в баллах",
            }),
          ],
        },
        {
          key: "vklive-requests",
          title: "VKLive",
          properties: [
            new BooleanProperty({
              name: "vklivePointsRequestsEnabled",
              value: false,
              displayName: "Заказ за баллы",
            }),
            new TextProperty({
              name: "music-vklive-request-title",
              value: "Заказ музыки",
              displayName: "Название награды",
            }),
            new NumberProperty({
              name: "music-vklive-request-cost",
              value: 100,
              displayName: "Стоимость в баллах",
            }),
          ],
        },
        {
          key: "kick-requests",
          title: "Kick",
          properties: [
            new BooleanProperty({
              name: "kickPointsRequestsEnabled",
              value: false,
              displayName: "Заказ за баллы",
            }),
            new TextProperty({
              name: "music-kick-request-title",
              value: "Заказ музыки",
              displayName: "Название награды",
            }),
            new NumberProperty({
              name: "music-kick-request-cost",
              value: 100,
              displayName: "Стоимость в баллах",
            }),
          ],
        },
      ],
    });
  }

  public help(): ReactNode {
    return (
      <>
        <Flex align="top" justify="space-between">
          <h3 className={`${classes.helptitle}`}>Виджет "Плеер"</h3>
          <CloseOverlayButton />
        </Flex>
        <div className={`${classes.helpdescription}`}>
          Проигрывает видео из реквеста из доната.
        </div>
        <h3 className={`${classes.helptitle}`}>Как подключить</h3>
        <div className={`${classes.helpdescription}`}>
          <ul>
            <li>В меню этого виджета (Плеер) скопировать ссылку</li>
            <li>
              Скопированную ссылку можно вставить как Dock в OBS либо открыть в
              браузере. В обоих случаях плеер будет принимать реквесты,
              проигрывать их.
            </li>
            <li>
              Чтобы уточнить цену реквестов и отобразить поле для их добавления,
              надо в разделе 'Страница доната' выставить поле 'Реквесты
              музыки/видео' в Enabled и прописать их стоимость в поле 'Стоимость
              реквестов'.
            </li>
          </ul>
        </div>
        <h3 className={`${classes.helptitle}`}>FAQ</h3>
        <div className={`${classes.helpdescription}`}>
          <ul>
            <li>
              Если подключен виджет алертов, плеер будет включать паузу на время
              алерта.
            </li>
            <li>
              Внутри виджета 'Плеер' можно включать/выключать реквесты - в меню
              кнопка 'Disable requests'.
            </li>
            <li>
              Если запущено несколько копий плеера, то реквесты будут попадать
              рандомно в один из них.
            </li>
            <li>
              С помощью виджета 'Remote Control' можно управлять плеером
              дистанционно (например модератору).
            </li>
          </ul>
        </div>
      </>
    );
  }
}
